import React from 'react'
import Dropzone from 'react-dropzone'

import { Box } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'

import DocumentText from 'modules/project_management/components/Dropzone/_DocumentText'

interface ImportDropzoneProps {
  fileDroppedFromDetailsPage?: File[] | undefined
  isIncorrectFile?: boolean
  label: React.ReactNode
  onDropFile: (files: File[]) => void
}

const ImportDropzone = ({
  fileDroppedFromDetailsPage,
  isIncorrectFile,
  label,
  onDropFile,
}: ImportDropzoneProps) => {
  const [fileName, setFileName] = React.useState<string | undefined>('')

  const onDrop = (files: File[]) => {
    onDropFile(files)
    const droppedFileName = files[0]?.name
    setFileName(droppedFileName)
  }

  const acceptedFiles = {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  }

  useEffect(() => {
    if (fileDroppedFromDetailsPage && !isIncorrectFile) {
      onDrop(fileDroppedFromDetailsPage)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Dropzone onDrop={onDrop} multiple={false} accept={acceptedFiles}>
      {({ getRootProps, getInputProps, isDragActive }) => (
        <div {...getRootProps()}>
          <Box
            background={isDragActive ? 'viridian100' : 'grey000White'}
            padding="s32"
            cursor="pointer"
            flexDirection="column"
            alignItems="center"
            borderRadius={{ all: 'abs006' }}
            border={{
              all: {
                width: 's2',
                style: 'dashed',
                color: 'grey400',
              },
            }}
          >
            <input data-testid="dropzone-input" {...getInputProps()} />
            <Box textAlign="center">
              <DocumentText fileName={fileName}>{label}</DocumentText>
            </Box>
          </Box>
        </div>
      )}
    </Dropzone>
  )
}

export default ImportDropzone
